import React, { useEffect, useState } from 'react';
import {
  getInputLanguage,
  INPUT_LANGUAGE_EVENT,
  INPUT_LANGUAGE_STORAGE_KEY,
} from '../../hooks/useMarathiInputTransliteration';
import './InputLanguageSwitcher.css';

const isTypingField = element => {
  if (!element || element.disabled || element.readOnly) return false;
  if (element instanceof HTMLTextAreaElement) return true;
  if (!(element instanceof HTMLInputElement)) return false;
  return !['button', 'checkbox', 'color', 'date', 'datetime-local', 'file', 'hidden',
    'month', 'number', 'password', 'radio', 'range', 'time', 'week'].includes(element.type);
};

export default function InputLanguageSwitcher() {
  const [language, setLanguage] = useState(getInputLanguage);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleLanguageChange = event => {
      const next = event?.detail || getInputLanguage();
      setLanguage(next);
    };
    window.addEventListener(INPUT_LANGUAGE_EVENT, handleLanguageChange);
    window.addEventListener('storage', handleLanguageChange);

    const handleFocus = event => {
      if (isTypingField(event.target)) {
        setLanguage(getInputLanguage());
        setVisible(true);
      }
    };
    const handlePointerDown = event => {
      if (!event.target.closest?.('.input-language-switcher') && !isTypingField(event.target)) {
        setVisible(false);
      }
    };
    document.addEventListener('focusin', handleFocus, true);
    document.addEventListener('pointerdown', handlePointerDown, true);
    return () => {
      window.removeEventListener(INPUT_LANGUAGE_EVENT, handleLanguageChange);
      window.removeEventListener('storage', handleLanguageChange);
      document.removeEventListener('focusin', handleFocus, true);
      document.removeEventListener('pointerdown', handlePointerDown, true);
    };
  }, []);

  const selectLanguage = nextLanguage => {
    window.localStorage.setItem(INPUT_LANGUAGE_STORAGE_KEY, nextLanguage);
    setLanguage(nextLanguage);
    window.dispatchEvent(new CustomEvent(INPUT_LANGUAGE_EVENT, { detail: nextLanguage }));
  };

  if (!visible) return null;

  return (
    <aside className="input-language-switcher" aria-label="टायपिंग भाषा निवडा">
      <span className="input-language-title">टायपिंग</span>
      <button type="button" className={language === 'mr' ? 'active' : ''}
        onMouseDown={event => event.preventDefault()} onClick={() => selectLanguage('mr')}
        aria-pressed={language === 'mr'} title="English अक्षरे टाइप करून मराठी लिहा">
        मराठी
      </button>
      <button type="button" className={language === 'en' ? 'active' : ''}
        onMouseDown={event => event.preventDefault()} onClick={() => selectLanguage('en')}
        aria-pressed={language === 'en'} title="Type in English">
        English
      </button>
    </aside>
  );
}
